import React from "react";
import "./Button.scss";

export default function Button({text, className, href, newTab}) {
  return (
    <div className={className}>
      <button className="main-button" href={href} target={newTab && "_blank"}>
      {text}
      </button>
    </div>
  );
}
